<script setup lang="ts">
useContextRefresh()
</script>

<template>
  <div class="reel-of-names-layout flex min-h-screen flex-col">
    <Toolbar />
    <main class="flex-grow">
      <slot />
    </main>
  </div>
</template>

<style>
.reel-of-names-layout { --reel-canvas: #edf2e9; background: var(--reel-canvas); }
.reel-of-names-layout > header { background: var(--reel-canvas); }
html.dark .reel-of-names-layout { --reel-canvas: #004660; }
html.dark .reel-of-names-layout > header { background: #004660 !important; }
</style>
